import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import BookmarkStar from 'common/icons/BookmarkStar';

import { SuiContainer, SuiStateButton, SuiConfirmDialogWrap, SuiTooltipPopover, SuiTextInput } from '@splashthat/sui';

import './EditViewFooter.styl';

const SAVE_BUTTON_LABEL = 'Save';
const DISMISS_BUTTON_LABEL = 'Cancel';
const SAVE_DIALOG_LABEL = 'Save Question As';
const SAVE_DIALOG_PLACEHOLDER = 'Question Name';

const ADD_TO_FORM_TEMPLATE_LIBRARY_LABEL = 'Add to Form Template Library';

export default class EditViewSaveQuestion extends React.Component {
    static propTypes = {
        initialValue: PropTypes.string,
        bookmarkButtonStatus: PropTypes.number.isRequired,
        blocked: PropTypes.bool,
        onClickSaveNode: PropTypes.func,
        onBlocked: PropTypes.func,
    };

    static defaultProps = {
        initialValue: '',
        onClickSaveNode: noop,
        onBlocked: noop,
        blocked: false,
    };

    state = {
        labelValue: this.props.initialValue,
    };

    handleInputChange = (ev, newValue) => {
        this.setState((state) => ({
            ...state,
            labelValue: newValue,
        }));
    };

    handleSave = () => {
        this.props.onClickSaveNode(this.state.labelValue);
    };

    render() {
        return (
            <SuiConfirmDialogWrap
                confirmLabel={SAVE_BUTTON_LABEL}
                dismissLabel={DISMISS_BUTTON_LABEL}
                dialogBody={
                    <SuiContainer>
                        <h2 className="EditViewSaveQuestion__title--text">{SAVE_DIALOG_LABEL}</h2>
                        <SuiTextInput
                            placeholder={SAVE_DIALOG_PLACEHOLDER}
                            value={this.state.labelValue}
                            onChange={this.handleInputChange}
                        />
                    </SuiContainer>
                }
                onConfirm={this.handleSave}
            >
                {(onClick) => (
                    <SuiTooltipPopover content={ADD_TO_FORM_TEMPLATE_LIBRARY_LABEL} openDelayed>
                        <SuiStateButton
                            variation="icon secondary"
                            size="small"
                            icon={<BookmarkStar />}
                            onClick={this.props.blocked ? this.props.onBlocked : onClick}
                            status={this.props.bookmarkButtonStatus}
                        />
                    </SuiTooltipPopover>
                )}
            </SuiConfirmDialogWrap>
        );
    }
}
